import { FullscreenDialog, IconButton } from '@/components/DesignSystem';
import CustomerDetails from '@/pages/FarmerList/CustomerDetails';
import { ApiUser } from '@api/interfaces';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ViewCustomerDetailsFullScreenModalProps {
  id: string,
  onClose: () => void,
  onViewAccount?: (customer: ApiUser) => void,
}

export const ViewCustomerDetailsFullScreenModal = ({
  id,
  onClose,
  onViewAccount,
}: ViewCustomerDetailsFullScreenModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <FullscreenDialog
      contentStyle={{ paddingX: 0 }}
      hideCloseButton
      maxWidth="lg"
      open
      testID="view-customer-details-modal"
      title={t($ => $.overview.customerAccount.modalTitle)}
      titleComponent={
        <IconButton
          onClick={onClose}
          sx={{ color: theme.palette.text.primary }}
          testID="back-to-customers-button"
        >
          <ArrowBackIcon />
        </IconButton>
      }
    >
      <CustomerDetails hideBackButton id={id} onViewAccount={onViewAccount} />
    </FullscreenDialog>
  );
};
